import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function createOrUpdateConsentSetting(
  useOrchidDefaultConsentSetting: Boolean,
) {
  const res = await fetchOrchidAPI(`/api/users/v1/orchid_pro/consent_setting`, {
    method: "POST",
    body: JSON.stringify({
      use_orchid_default: useOrchidDefaultConsentSetting,
    }),
  });
  if (!res.ok) {
    const responseText = await res.text();
    console.error(getErrorDetail(responseText));
  }
  return res;
}
